// extracted by mini-css-extract-plugin
module.exports = {"divPpal":"financial_divPpal__2_cx6","indError":"financial_indError__3nSjq","tdError":"financial_tdError__3C6jV"};